import { DeepClone } from "./insole-web-common/src/util.js";
import { IsNullish } from "./util.js";
import { GetSelectedPointPairLateralIndex, GetSelectedPointPairMedialIndex, GetWidthPointPairLateralIndex, GetWidthPointPairMedialIndex, } from "./border-width-parameters.js";
import { insoleParameterChanged } from "./ui/insole-parameter-change.event.js";
export var UpdateDirection;
(function (UpdateDirection) {
    UpdateDirection[UpdateDirection["None"] = 0] = "None";
    UpdateDirection[UpdateDirection["UIToData"] = 1] = "UIToData";
    UpdateDirection[UpdateDirection["DataToUI"] = 2] = "DataToUI";
    UpdateDirection[UpdateDirection["Both"] = 3] = "Both";
})(UpdateDirection || (UpdateDirection = {}));
export const customInsoleParameters = [
    "widthModification",
    "rbwLinesEnabled",
    "flatHeel",
    "archMedialProximalStartOffset",
    "archMedialProximalHeight",
    "archMedialProximalPos",
    "archMedialDistalHeight",
    "archMedialDistalPos",
    "archMedialDistalDecay",
    "archMedialShape",
    "archMedialWidth",
    "archMiddleStart",
    "archMiddleProximalPos",
    "archMiddleDistalPos",
    "archMiddleRaise",
    "archWedge",
    "archWedgePatternEnabled",
    "archMpfEnabled",
    "archMpfAdditionalPoints",
    "archMpfDistalPoint",
    "archMpfProximalPoint",
    "archLateralProximalStartOffset",
    "archLateralProximalHeight",
    "archLateralProximalPos",
    "archLateralDistalHeight",
    "archLateralDistalPos",
    "archLateralDistalDecay",
    "archLateralShape",
    "archModification",
    "archHeightFittingMethod",
    "forefootPostingBalanceToRearfoot",
    "forefootPostingAngle",
    "forefootPostingRange",
    "forefootPostingMedialEdge",
    "forefootPostingLateralEdge",
    "forefootPostingProximalEdge",
    "forefootPostingExtrinsic",
    "forefootPostingMeshEnabled",
    "forefootPostingMeshBaseType",
    "forefootPostingHexagonPatternEnabled",
    "heelCupEnabled",
    "heelCupHeight",
    "heelCupMedialFalloffLengthRatio",
    "heelCupLateralFalloffLengthRatio",
    "heelCupCurvatureShape",
    "heelCupThicknessEnabled",
    "heelCupThickness",
    "heelPostingExtrinsicEnabled",
    "heelPostingIntrinsicEnabled",
    "heelPostingPostType",
    "heelPostingAngle",
    "heelPostingRange",
    "heelPostingHeelLift",
    "heelPostingCurvature",
    "heelPostingUndercut",
    "heelPostingDistalEdge",
    "heelPostingDistalPitch",
    "heelPostingUseAutoDistalPitch",
    "medialFlangeEnabled",
    "medialFlangeHeight",
    "medialFlangeWidth",
    "medialFlangeApexPoint",
    "medialFlangeThickness",
    "lateralFlangeEnabled",
    "lateralFlangeHeight",
    "lateralFlangeWidth",
    "lateralFlangeThickness",
    "lateralFlangeApexPoint",
    "sideRoundingRadius",
    "embossedText",
    "embossedTextPositionU",
    "embossedTextPositionV",
    "embossedRotation",
    "embossedFontSize",
    "embossedDepth",
    "embossedLogoNameOverride",
    "insoleTemplateSizeType",
    "insoleTemplate",
    "forefootWidth",
    "heelWidth",
    "currentBorderWidthMedialLockDistal",
    "currentBorderWidthMedialProximalPoint",
    "currentBorderWidthMedialDistalPoint",
    "currentBorderWidthMedialProximalWidth",
    "currentBorderWidthMedialDistalWidth",
    "currentBorderWidthMedialSmoothing",
    "currentBorderWidthLateralLockDistal",
    "currentBorderWidthLateralProximalPoint",
    "currentBorderWidthLateralDistalPoint",
    "currentBorderWidthLateralProximalWidth",
    "currentBorderWidthLateralDistalWidth",
    "currentBorderWidthLateralSmoothing",
    "borderWidthMedialPointPairData0",
    "borderWidthMedialPointPairData1",
    "borderWidthMedialPointPairData2",
    "borderWidthMedialPointPairData3",
    "borderWidthLateralPointPairData0",
    "borderWidthLateralPointPairData1",
    "borderWidthLateralPointPairData2",
    "borderWidthLateralPointPairData3",
    // Implement region based width functionality using border width
    // This should be used instead of region based width
    // TODO?: remove region based width from the engine
    "bwRegionBasedWidthProximalPoint",
    "bwRegionBasedWidthDistalPoint",
    "bwRegionBasedWidthWidth",
    "bwRegionBasedWidthSmoothing",
    "bwRegionBasedWidthLockDistal",
    "bwRegionBasedWidthMedialSideEnabled",
    "bwRegionBasedWidthLateralSideEnabled",
    "thickInsoleEnabled",
    "thickInsoleMiddlePosition",
    "thickInsoleHeelUndercut",
    "thickInsoleMedialUndercut",
    "thickInsoleLateralUndercut",
    "zoningShapesEnabledOnThick",
    "zoningShapesVisibleOnThick",
    "zoningShapesEnabledOnLattice",
    "zoningShapesVisibleOnLattice",
    "latticeEnabled",
    "latticePreview",
    "latticeDefaultCellSize",
    "latticeDefaultInnerBeamThickness",
    "latticeDefaultSurfaceBeamThickness",
    "latticeDefaultRingThickness",
    "latticeDefaultTopCoverEnabled",
    "latticeDefaultTopCoverThickness",
    "latticeEnabledZones",
    "latticeZoneShapes",
    "latticeZoneInnerBeamThicknesses",
    "latticeZoneSurfaceBeamThicknesses",
    "latticeSelectedZoneIndex",
    "latticeSelectedZoneEnabled",
    "latticeSelectedZoneInnerBeamThickness",
    "latticeSelectedZoneSurfaceBeamThickness",
    "metatarsalPadEnabled",
    "metatarsalPadReferencePointU",
    "metatarsalPadReferencePointV",
    "metatarsalPadShapeType",
    "metatarsalPadHeight",
    "metatarsalPadScaleX",
    "metatarsalPadScaleY",
    "metatarsalPadRotationDegrees",
    "fascialGrooveEnabled",
    "fascialGrooveReferencePointU",
    "fascialGrooveReferencePointV",
    "fascialGrooveHeight",
    "fascialGrooveScaleX",
    "fascialGrooveScaleY",
    "fascialGrooveRotationDegrees",
    "styloidEnabled",
    "styloidReferencePointU",
    "styloidReferencePointV",
    "styloidHeight",
    "styloidScaleX",
    "styloidScaleY",
    "styloidRotationDegrees",
    "navicularDepressionEnabled",
    "navicularDepressionReferencePointU",
    "navicularDepressionReferencePointV",
    "navicularDepressionHeight",
    "navicularDepressionScaleX",
    "navicularDepressionScaleY",
    "navicularDepressionRotationDegrees",
    "currentCutoutShapeType",
    "currentCutoutSizeD1",
    "currentCutoutSizeD2",
    "currentCutoutRotation",
    "currentCutoutLocationU",
    "currentCutoutLocationV",
    "currentCutoutCustomShapeNumCps",
    "currentCutoutCustomShapeCps",
    "cutoutShapeData0",
    "cutoutShapeData1",
    "cutoutShapeData2",
    "cutoutShapeData3",
    "currentReductionShapeEnabled",
    "currentReductionShapeType",
    "currentReductionSizeD1",
    "currentReductionSizeD2",
    "currentReductionRotation",
    "currentReductionLocationU",
    "currentReductionLocationV",
    "reductionShapeDataHeel",
    "reductionShapeDataMedialArch",
    "reductionShapeDataLateralArch",
    "reductionShapeDataMetatarsal",
    "currentDomesAndWellsShapeType",
    "currentDomesAndWellsHeight",
    "currentDomesAndWellsSizeD1",
    "currentDomesAndWellsSizeD2",
    "currentDomesAndWellsSlopeS1",
    "currentDomesAndWellsSlopeS2",
    "currentDomesAndWellsRotation",
    "currentDomesAndWellsLocationU",
    "currentDomesAndWellsLocationV",
    "currentDomesAndWellsCustomShapeNumCps",
    "currentDomesAndWellsCustomShapeCps",
    "domesAndWellsShapeData0",
    "domesAndWellsShapeData1",
    "domesAndWellsShapeData2",
    "domesAndWellsShapeData3",
    "medialArchReinforcementEnabled",
    "medialArchReinforcementType",
    "medialArchReinforcementThickness",
    "medialArchReinforcementProximalStretch",
    "medialArchReinforcementDistalStretch",
    "medialArchReinforcementLateralStretch",
    "lateralArchReinforcementEnabled",
    "lateralArchReinforcementType",
    "lateralArchReinforcementThickness",
    "lateralArchReinforcementProximalStretch",
    "lateralArchReinforcementDistalStretch",
    "lateralArchReinforcementLateralStretch",
    "firstMetaCutoutRayLength",
    "firstMetaCutoutRayWidth",
    "firstMetaCutoutMPJLength",
    "firstMetaCutoutMPJWidth",
    "fifthMetaCutoutRayLength",
    "fifthMetaCutoutRayWidth",
    "fifthMetaCutoutMPJLength",
    "fifthMetaCutoutMPJWidth",
    "mortonsExtensionEnabled",
    "mortonsExtensionWidthPercent",
    "mortonsExtensionLengthPercent",
    "mortonsExtensionThickness",
    "mortonsExtensionLateralEdgeAngle",
    "mortonsExtensionMedialEdgeAngle",
    "mortonsExtensionType",
    "reverseMortonsExtensionEnabled",
    "reverseMortonsExtensionWidthPercent",
    "reverseMortonsExtensionLengthPercent",
    "reverseMortonsExtensionThickness",
    "reverseMortonsExtensionLateralEdgeAngle",
    "reverseMortonsExtensionMedialEdgeAngle",
    "reverseMortonsExtensionType",
    /* LeoShapes */
    "insoleShape",
    "sulcusEnabled", // Do not mirror!
    "leofullLengthEnabled", // Do not mirror!
    "leoMortonsEnabled", // Do not mirror!
    "gaitPlateEnabled", // Do not mirror!
    "sulcusReverse",
    "sulcusDistalAreaThickness",
    "sulcusInternalPreset",
    "sulcusMpj1DistalExtension",
    "sulcusMpj5DistalExtension",
    "sulcusShoeWidth",
    "sulcusLengthScaleRatio",
    "sulcusWidthScaleRatio",
    "leoMortonsWidthPercent",
    "leoMortonsLengthPercent",
    "leoMortonsReverseWidthPercent",
    "leoMortonsReverseLengthPercent",
    /** Same as sulcusReserve, but opposite. */
    "gaitPlateReverse",
    "gaitPlateLength",
    "gaitPlateCurvature",
    "gaitPlateReverseLength",
    "gaitPlateReverseCurvature",
];
// Maximum number of border width pairs used for the relevant tools
// (currently dimensions and region based width)
let usedBorderWidthPairs = 2;
let selectedCutoutShapeIndex = 0;
let selectedReductionShapeIndex = 0;
let selectedDomesAndWellsShapeIndex = 0;
const reductionShapeTypes = [
    "ReductionHeel",
    "ReductionMedialArch",
    "ReductionLateralArch",
    "ReductionMetatarsal",
];
export function SetSelectedCutoutShapeIndex(index) {
    selectedCutoutShapeIndex = index;
}
export function GetSelectedCutoutShapeIndex() {
    return selectedCutoutShapeIndex;
}
export function SetSelectedReductionShapeIndex(index) {
    selectedReductionShapeIndex = index;
}
export function GetSelectedReductionShapeIndex() {
    return selectedReductionShapeIndex;
}
export function SetSelectedDomesAndWellsShapeIndex(index) {
    selectedDomesAndWellsShapeIndex = index;
}
export function GetSelectedDomesAndWellsShapeIndex() {
    return selectedDomesAndWellsShapeIndex;
}
function GetValidSideForBWRegionBasedWidth(params) {
    return params.insoleParams.borderWidthNumMedialPointPairs > 0
        ? params.insoleParams.borderWidthMedialPoints[0]
        : params.insoleParams.borderWidthLateralPoints[0];
}
const insoleParameterCustomHandlers = new Map();
function RegisterCustomInsoleParameterHandlers(...handlers) {
    for (const [key, getter, setter] of handlers) {
        insoleParameterCustomHandlers.set(key, { getter, setter });
    }
}
function RegisterSimpleParameterHandlers(...handlers) {
    RegisterCustomInsoleParameterHandlers(...handlers.map(([key, path]) => {
        // The path is verified by the type system, so this is safe
        const segments = path.split(".");
        const propertyName = segments[segments.length - 1];
        // Cannot return a reference to a specific property, so just return the parent object, and access it by the key
        function GetBaseObject(params) {
            let current = params;
            for (let i = 0; i < segments.length - 1; ++i) {
                current = current[segments[i]];
            }
            return current;
        }
        const handlerInput = [
            key,
            params => GetBaseObject(params)[propertyName],
            (params, value) => (GetBaseObject(params)[propertyName] = value),
        ];
        return handlerInput;
    }));
}
RegisterSimpleParameterHandlers(["archMedialProximalStartOffset", "insoleParams.archParameters.medial.proximalStartOffset"], ["archMedialProximalHeight", "insoleParams.archParameters.medial.proximalApexHeight"], ["archMedialProximalPos", "insoleParams.archParameters.medial.proximalApexPosition"], ["archMedialDistalHeight", "insoleParams.archParameters.medial.distalApexHeight"], ["archMedialDistalPos", "insoleParams.archParameters.medial.distalApexPosition"], ["archMedialDistalDecay", "insoleParams.archParameters.medial.distalDecay"], ["archMedialShape", "insoleParams.archParameters.medial.archShape"], ["archMedialWidth", "insoleParams.archParameters.medial.archWidth"], ["archMiddleStart", "insoleParams.archParameters.midfootRaise.proximalStartRatio"], ["archMiddleProximalPos", "insoleParams.archParameters.midfootRaise.proximalApexRatio"], ["archMiddleDistalPos", "insoleParams.archParameters.midfootRaise.distalApexRatio"], ["archMiddleRaise", "insoleParams.archParameters.midfootRaise.raise"], ["archWedge", "insoleParams.archParameters.wedgeFillHeight"], ["archWedgePatternEnabled", "insoleParams.archParameters.wedgePatternEnabled"], ["archMpfDistalPoint", "insoleParams.archParameters.multipointFittingRange.x"], ["archMpfProximalPoint", "insoleParams.archParameters.multipointFittingRange.y"], ["archLateralProximalStartOffset", "insoleParams.archParameters.lateral.proximalStartOffset"], ["archLateralProximalHeight", "insoleParams.archParameters.lateral.proximalApexHeight"], ["archLateralProximalPos", "insoleParams.archParameters.lateral.proximalApexPosition"], ["archLateralDistalHeight", "insoleParams.archParameters.lateral.distalApexHeight"], ["archLateralDistalPos", "insoleParams.archParameters.lateral.distalApexPosition"], ["archLateralDistalDecay", "insoleParams.archParameters.lateral.distalDecay"], ["archLateralShape", "insoleParams.archParameters.lateral.archShape"], ["rbwLinesEnabled", "rbwLinesVisible"], ["forefootPostingBalanceToRearfoot", "insoleParams.forefootPostParameters.balanceToRearfoot"], ["forefootPostingAngle", "insoleParams.forefootPostParameters.postAngle"], ["forefootPostingRange", "insoleParams.forefootPostParameters.effectRangeParameters.range.w"], ["forefootPostingMedialEdge", "insoleParams.forefootPostParameters.meshMedialEdgeRatio"], ["forefootPostingLateralEdge", "insoleParams.forefootPostParameters.meshLateralEdgeRatio"], ["forefootPostingProximalEdge", "insoleParams.forefootPostParameters.meshProximalEdgeRatio"], ["forefootPostingMeshEnabled", "insoleParams.forefootPostParameters.meshEnabled"], ["forefootPostingExtrinsic", "insoleParams.forefootPostParameters.extrinsic"], ["forefootPostingMeshBaseType", "insoleParams.forefootPostParameters.meshBaseType"], ["forefootPostingHexagonPatternEnabled", "insoleParams.forefootPostParameters.hexagonPatternEnabled"], ["heelCupEnabled", "insoleParams.heelCupParameters.enabled"], ["heelCupHeight", "insoleParams.heelCupParameters.seatHeight"], ["heelCupMedialFalloffLengthRatio", "insoleParams.heelCupParameters.medialFalloffLengthRatio"], ["heelCupLateralFalloffLengthRatio", "insoleParams.heelCupParameters.lateralFalloffLengthRatio"], ["heelCupCurvatureShape", "insoleParams.heelCupParameters.curvatureShape"], ["heelCupThicknessEnabled", "insoleParams.heelCupParameters.cupThicknessEnabled"], ["heelCupThickness", "insoleParams.heelCupParameters.cupThickness"], ["heelPostingExtrinsicEnabled", "insoleParams.heelPostParameters.extrinsicEnabled"], ["heelPostingIntrinsicEnabled", "insoleParams.heelPostParameters.intrinsicEnabled"], ["heelPostingPostType", "insoleParams.heelPostParameters.postType"], ["heelPostingAngle", "insoleParams.heelPostParameters.rollAngle"], ["heelPostingRange", "insoleParams.heelPostParameters.effectRangeParameters.range.x"], ["heelPostingHeelLift", "insoleParams.heelPostParameters.heelLift"], ["heelPostingCurvature", "insoleParams.heelPostParameters.curvature"], ["heelPostingUndercut", "insoleParams.heelPostParameters.undercut"], ["heelPostingDistalEdge", "insoleParams.heelPostParameters.distalEdgeRatio"], ["heelPostingDistalPitch", "insoleParams.heelPostParameters.distalPitch"], ["heelPostingUseAutoDistalPitch", "insoleParams.heelPostParameters.useAutoDistalPitch"], ["medialFlangeEnabled", "insoleParams.medialFlangeParameters.enabled"], ["medialFlangeHeight", "insoleParams.medialFlangeParameters.height"], ["medialFlangeWidth", "insoleParams.medialFlangeParameters.width"], ["medialFlangeApexPoint", "insoleParams.medialFlangeParameters.interpolationPointPercentage"], ["medialFlangeThickness", "insoleParams.medialFlangeParameters.thickness"], ["lateralFlangeEnabled", "insoleParams.lateralFlangeParameters.enabled"], ["lateralFlangeHeight", "insoleParams.lateralFlangeParameters.height"], ["lateralFlangeWidth", "insoleParams.lateralFlangeParameters.width"], ["lateralFlangeThickness", "insoleParams.lateralFlangeParameters.thickness"], ["lateralFlangeApexPoint", "insoleParams.lateralFlangeParameters.interpolationPointPercentage"], ["sideRoundingRadius", "meshGenParams.sideRoundness"], ["embossedText", "exportParams.embossedText"], ["embossedTextPositionU", "exportParams.embossedTextPositionUV.x"], ["embossedTextPositionV", "exportParams.embossedTextPositionUV.y"], ["embossedRotation", "exportParams.embossedRotationDegrees"], ["embossedFontSize", "exportParams.embossedFontSize"], ["embossedDepth", "exportParams.embossedDepth"], ["embossedLogoNameOverride", "exportParams.embossedLogoNameOverride"], ["insoleTemplate", "selectedTemplate"], ["insoleTemplateSizeType", "selectedTemplateSizeType"], ["insoleShape", "insoleParams.insoleShape"], ["sulcusReverse", "insoleParams.sulcusParameters.reverse"], ["sulcusDistalAreaThickness", "insoleParams.sulcusParameters.distalAreaThickness"], ["sulcusInternalPreset", "insoleParams.sulcusParameters.internalPreset"], ["sulcusMpj1DistalExtension", "insoleParams.sulcusParameters.mpj1DistalExtension"], ["sulcusMpj5DistalExtension", "insoleParams.sulcusParameters.mpj5DistalExtension"], ["sulcusShoeWidth", "insoleParams.sulcusParameters.shoeWidth"], ["sulcusLengthScaleRatio", "insoleParams.sulcusParameters.lengthScaleRatio"], ["sulcusWidthScaleRatio", "insoleParams.sulcusParameters.widthScaleRatio"], ["leoMortonsWidthPercent", "insoleParams.mortonsParameters.widthPercent"], ["leoMortonsLengthPercent", "insoleParams.mortonsParameters.lengthPercent"], ["leoMortonsReverseWidthPercent", "insoleParams.reverseMortonsParameters.widthPercent"], ["leoMortonsReverseLengthPercent", "insoleParams.reverseMortonsParameters.lengthPercent"], ["gaitPlateLength", "insoleParams.gaitPlateParameters.lengthPercent"], ["gaitPlateCurvature", "insoleParams.gaitPlateParameters.distalTangentStrength"], ["gaitPlateReverseLength", "insoleParams.reverseGaitPlateParameters.lengthPercent"], ["gaitPlateReverseCurvature", "insoleParams.reverseGaitPlateParameters.distalTangentStrength"], ["thickInsoleEnabled", "insoleParams.solidParameters.enabled"], ["thickInsoleMiddlePosition", "insoleParams.solidParameters.midPoint"], ["thickInsoleHeelUndercut", "insoleParams.solidParameters.heel"], ["thickInsoleMedialUndercut", "insoleParams.solidParameters.medial"], ["thickInsoleLateralUndercut", "insoleParams.solidParameters.lateral"], ["metatarsalPadEnabled", "insoleParams.metatarsalPadParameters.heightMapParameters.enabled"], ["metatarsalPadReferencePointU", "insoleParams.metatarsalPadParameters.heightMapParameters.referencePointU"], ["metatarsalPadReferencePointV", "insoleParams.metatarsalPadParameters.heightMapParameters.referencePointV"], ["metatarsalPadShapeType", "insoleParams.metatarsalPadParameters.shapeType"], ["metatarsalPadHeight", "insoleParams.metatarsalPadParameters.heightMapParameters.height"], ["metatarsalPadScaleX", "insoleParams.metatarsalPadParameters.heightMapParameters.scaleX"], ["metatarsalPadScaleY", "insoleParams.metatarsalPadParameters.heightMapParameters.scaleY"], ["metatarsalPadRotationDegrees", "insoleParams.metatarsalPadParameters.heightMapParameters.rotationDegrees"], ["fascialGrooveEnabled", "insoleParams.fascialGrooveParameters.enabled"], ["fascialGrooveReferencePointU", "insoleParams.fascialGrooveParameters.referencePointU"], ["fascialGrooveReferencePointV", "insoleParams.fascialGrooveParameters.referencePointV"], ["fascialGrooveHeight", "insoleParams.fascialGrooveParameters.height"], ["fascialGrooveScaleX", "insoleParams.fascialGrooveParameters.scaleX"], ["fascialGrooveScaleY", "insoleParams.fascialGrooveParameters.scaleY"], ["fascialGrooveRotationDegrees", "insoleParams.fascialGrooveParameters.rotationDegrees"], ["styloidEnabled", "insoleParams.styloidParameters.enabled"], ["styloidReferencePointU", "insoleParams.styloidParameters.referencePointU"], ["styloidReferencePointV", "insoleParams.styloidParameters.referencePointV"], ["styloidHeight", "insoleParams.styloidParameters.height"], ["styloidScaleX", "insoleParams.styloidParameters.scaleX"], ["styloidScaleY", "insoleParams.styloidParameters.scaleY"], ["styloidRotationDegrees", "insoleParams.styloidParameters.rotationDegrees"], ["navicularDepressionEnabled", "insoleParams.navicularDepressionParameters.enabled"], ["navicularDepressionReferencePointU", "insoleParams.navicularDepressionParameters.referencePointU"], ["navicularDepressionReferencePointV", "insoleParams.navicularDepressionParameters.referencePointV"], ["navicularDepressionHeight", "insoleParams.navicularDepressionParameters.height"], ["navicularDepressionScaleX", "insoleParams.navicularDepressionParameters.scaleX"], ["navicularDepressionScaleY", "insoleParams.navicularDepressionParameters.scaleY"], ["navicularDepressionRotationDegrees", "insoleParams.navicularDepressionParameters.rotationDegrees"], ["medialArchReinforcementEnabled", "insoleParams.medialArchReinforcementParameters.enabled"], ["medialArchReinforcementType", "insoleParams.medialArchReinforcementParameters.type"], ["medialArchReinforcementThickness", "insoleParams.medialArchReinforcementParameters.thickness"], ["medialArchReinforcementProximalStretch", "insoleParams.medialArchReinforcementParameters.proximalStretch"], ["medialArchReinforcementDistalStretch", "insoleParams.medialArchReinforcementParameters.distalStretch"], ["medialArchReinforcementLateralStretch", "insoleParams.medialArchReinforcementParameters.lateralStretch"], ["lateralArchReinforcementEnabled", "insoleParams.lateralArchReinforcementParameters.enabled"], ["lateralArchReinforcementType", "insoleParams.lateralArchReinforcementParameters.type"], ["lateralArchReinforcementThickness", "insoleParams.lateralArchReinforcementParameters.thickness"], ["lateralArchReinforcementProximalStretch", "insoleParams.lateralArchReinforcementParameters.proximalStretch"], ["lateralArchReinforcementDistalStretch", "insoleParams.lateralArchReinforcementParameters.distalStretch"], ["lateralArchReinforcementLateralStretch", "insoleParams.lateralArchReinforcementParameters.lateralStretch"], ["firstMetaCutoutRayLength", "insoleParams.leoFirstRayCutoutFirstRaySize.x"], ["firstMetaCutoutRayWidth", "insoleParams.leoFirstRayCutoutFirstRaySize.y"], ["firstMetaCutoutMPJLength", "insoleParams.leoFirstRayCutoutMPJ1Size.x"], ["firstMetaCutoutMPJWidth", "insoleParams.leoFirstRayCutoutMPJ1Size.y"], ["fifthMetaCutoutRayLength", "insoleParams.fifthMetatarsalCutoutFirstRaySize.x"], ["fifthMetaCutoutRayWidth", "insoleParams.fifthMetatarsalCutoutFirstRaySize.y"], ["fifthMetaCutoutMPJLength", "insoleParams.fifthMetatarsalCutoutMPJSize.x"], ["fifthMetaCutoutMPJWidth", "insoleParams.fifthMetatarsalCutoutMPJSize.y"], ["mortonsExtensionEnabled", "insoleParams.mortonsParameters.enabled"], ["mortonsExtensionWidthPercent", "insoleParams.mortonsParameters.widthPercent"], ["mortonsExtensionLengthPercent", "insoleParams.mortonsParameters.lengthPercent"], ["mortonsExtensionThickness", "insoleParams.mortonsParameters.thickness"], ["mortonsExtensionLateralEdgeAngle", "insoleParams.mortonsParameters.lateralEdgeAngle"], ["mortonsExtensionMedialEdgeAngle", "insoleParams.mortonsParameters.medialEdgeAngle"], ["mortonsExtensionType", "insoleParams.mortonsParameters.rigidity"], ["reverseMortonsExtensionEnabled", "insoleParams.reverseMortonsParameters.enabled"], ["reverseMortonsExtensionWidthPercent", "insoleParams.reverseMortonsParameters.widthPercent"], ["reverseMortonsExtensionLengthPercent", "insoleParams.reverseMortonsParameters.lengthPercent"], ["reverseMortonsExtensionThickness", "insoleParams.reverseMortonsParameters.thickness"], ["reverseMortonsExtensionLateralEdgeAngle", "insoleParams.reverseMortonsParameters.lateralEdgeAngle"], ["reverseMortonsExtensionMedialEdgeAngle", "insoleParams.reverseMortonsParameters.medialEdgeAngle"], ["reverseMortonsExtensionType", "insoleParams.reverseMortonsParameters.rigidity"], ["latticeDefaultCellSize", "insoleParams.latticeParameters.cellSize"], ["latticeDefaultInnerBeamThickness", "insoleParams.latticeParameters.edgeThickness"], ["latticeDefaultSurfaceBeamThickness", "insoleParams.latticeParameters.beamThickness"], ["latticeDefaultRingThickness", "insoleParams.latticeParameters.ringThickness"], ["latticeDefaultTopCoverEnabled", "insoleParams.latticeParameters.topCoverEnabled"], ["latticeDefaultTopCoverThickness", "insoleParams.latticeParameters.topCoverThickness"], ["latticeSelectedZoneIndex", "selectedLatticeZoneIndex"], ["latticeEnabledZones", "latticeEnabledZones"], ["latticeZoneShapes", "insoleParams.latticeParameters.zones"], ["latticeZoneInnerBeamThicknesses", "insoleParams.latticeParameters.zoneBeamThickness"], ["latticeZoneSurfaceBeamThicknesses", "insoleParams.latticeParameters.zoneEdgeThickness"]);
RegisterCustomInsoleParameterHandlers([
    "flatHeel",
    params => {
        return params.insoleParams.bottomThicknessReductionMode == "Full";
    },
    (params, value) => {
        params.insoleParams.bottomThicknessReductionMode = value === true ? "Full" : "RoundedHeel";
    },
], [
    "widthModification",
    params => {
        return params.widthModification;
    },
    (params, value) => {
        params.widthModification = value;
    },
], [
    "archMpfEnabled",
    params => params.archMpfEnabled,
    (params, value) => {
        params.archMpfEnabled = value;
        params.insoleParams.archParameters.multipointFittingAdditionalPoints = value
            ? params.archMpfAdditionalPoints
            : 0;
    },
], [
    "archMpfAdditionalPoints",
    params => params.archMpfAdditionalPoints,
    (params, value) => {
        params.archMpfAdditionalPoints = value;
        params.insoleParams.archParameters.multipointFittingAdditionalPoints = params.archMpfEnabled ? value : 0;
    },
], ["archModification", params => params.archModification, (params, value) => (params.archModification = value)], [
    "archHeightFittingMethod",
    params => params.archHeightFittingMethod,
    (params, value) => (params.archHeightFittingMethod = value),
], [
    "forefootWidth",
    params => {
        return (params.insoleParams.physicalWidthMet +
            2.0 * params.insoleParams.borderWidthMedialPoints[GetWidthPointPairMedialIndex()].distalWidth);
    },
    (params, value) => {
        params.insoleParams.borderWidthMedialPoints[GetWidthPointPairMedialIndex()].distalWidth =
            (value - params.insoleParams.physicalWidthMet) / 2.0;
        params.insoleParams.borderWidthLateralPoints[GetWidthPointPairLateralIndex()].distalWidth =
            (value - params.insoleParams.physicalWidthMet) / 2.0;
    },
], [
    "heelWidth",
    params => {
        return (params.insoleParams.physicalWidth +
            2.0 * params.insoleParams.borderWidthMedialPoints[GetWidthPointPairMedialIndex()].proximalWidth);
    },
    (params, value) => {
        params.insoleParams.borderWidthMedialPoints[GetWidthPointPairMedialIndex()].proximalWidth =
            (value - params.insoleParams.physicalWidth) / 2.0;
        params.insoleParams.borderWidthLateralPoints[GetWidthPointPairLateralIndex()].proximalWidth =
            (value - params.insoleParams.physicalWidth) / 2.0;
    },
], [
    "currentBorderWidthMedialLockDistal",
    params => params.insoleParams.borderWidthMedialPoints[GetSelectedPointPairMedialIndex()].lockDistal,
    (params, value) => (params.insoleParams.borderWidthMedialPoints[GetSelectedPointPairMedialIndex()].lockDistal = value),
], [
    "currentBorderWidthMedialProximalPoint",
    params => params.insoleParams.borderWidthMedialPoints[GetSelectedPointPairMedialIndex()].proximalPoint,
    (params, value) => (params.insoleParams.borderWidthMedialPoints[GetSelectedPointPairMedialIndex()].proximalPoint = value),
], [
    "currentBorderWidthMedialDistalPoint",
    params => params.insoleParams.borderWidthMedialPoints[GetSelectedPointPairMedialIndex()].distalPoint,
    (params, value) => (params.insoleParams.borderWidthMedialPoints[GetSelectedPointPairMedialIndex()].distalPoint = value),
], [
    "currentBorderWidthMedialProximalWidth",
    params => params.insoleParams.borderWidthMedialPoints[GetSelectedPointPairMedialIndex()].proximalWidth,
    (params, value) => (params.insoleParams.borderWidthMedialPoints[GetSelectedPointPairMedialIndex()].proximalWidth = value),
], [
    "currentBorderWidthMedialDistalWidth",
    params => params.insoleParams.borderWidthMedialPoints[GetSelectedPointPairMedialIndex()].distalWidth,
    (params, value) => (params.insoleParams.borderWidthMedialPoints[GetSelectedPointPairMedialIndex()].distalWidth = value),
], [
    "currentBorderWidthMedialSmoothing",
    params => params.insoleParams.borderWidthMedialPoints[GetSelectedPointPairMedialIndex()].smoothing,
    (params, value) => (params.insoleParams.borderWidthMedialPoints[GetSelectedPointPairMedialIndex()].smoothing = value),
], [
    "currentBorderWidthLateralLockDistal",
    params => params.insoleParams.borderWidthLateralPoints[GetSelectedPointPairLateralIndex()].lockDistal,
    (params, value) => (params.insoleParams.borderWidthLateralPoints[GetSelectedPointPairLateralIndex()].lockDistal = value),
], [
    "currentBorderWidthLateralProximalPoint",
    params => params.insoleParams.borderWidthLateralPoints[GetSelectedPointPairLateralIndex()].proximalPoint,
    (params, value) => (params.insoleParams.borderWidthLateralPoints[GetSelectedPointPairLateralIndex()].proximalPoint = value),
], [
    "currentBorderWidthLateralDistalPoint",
    params => params.insoleParams.borderWidthLateralPoints[GetSelectedPointPairLateralIndex()].distalPoint,
    (params, value) => (params.insoleParams.borderWidthLateralPoints[GetSelectedPointPairLateralIndex()].distalPoint = value),
], [
    "currentBorderWidthLateralProximalWidth",
    params => params.insoleParams.borderWidthLateralPoints[GetSelectedPointPairLateralIndex()].proximalWidth,
    (params, value) => (params.insoleParams.borderWidthLateralPoints[GetSelectedPointPairLateralIndex()].proximalWidth = value),
], [
    "currentBorderWidthLateralDistalWidth",
    params => params.insoleParams.borderWidthLateralPoints[GetSelectedPointPairLateralIndex()].distalWidth,
    (params, value) => (params.insoleParams.borderWidthLateralPoints[GetSelectedPointPairLateralIndex()].distalWidth = value),
], [
    "currentBorderWidthLateralSmoothing",
    params => params.insoleParams.borderWidthLateralPoints[GetSelectedPointPairLateralIndex()].smoothing,
    (params, value) => (params.insoleParams.borderWidthLateralPoints[GetSelectedPointPairLateralIndex()].smoothing = value),
], [
    "borderWidthMedialPointPairData0",
    params => DeepClone(params.insoleParams.borderWidthMedialPoints[0]),
    (params, value) => (params.insoleParams.borderWidthMedialPoints[0] = DeepClone(value)),
], [
    "borderWidthMedialPointPairData1",
    params => DeepClone(params.insoleParams.borderWidthMedialPoints[1]),
    (params, value) => (params.insoleParams.borderWidthMedialPoints[1] = DeepClone(value)),
], [
    "borderWidthMedialPointPairData2",
    params => DeepClone(params.insoleParams.borderWidthMedialPoints[2]),
    (params, value) => (params.insoleParams.borderWidthMedialPoints[2] = DeepClone(value)),
], [
    "borderWidthMedialPointPairData3",
    params => DeepClone(params.insoleParams.borderWidthMedialPoints[3]),
    (params, value) => (params.insoleParams.borderWidthMedialPoints[3] = DeepClone(value)),
], [
    "borderWidthLateralPointPairData0",
    params => DeepClone(params.insoleParams.borderWidthLateralPoints[0]),
    (params, value) => (params.insoleParams.borderWidthLateralPoints[0] = DeepClone(value)),
], [
    "borderWidthLateralPointPairData1",
    params => DeepClone(params.insoleParams.borderWidthLateralPoints[1]),
    (params, value) => (params.insoleParams.borderWidthLateralPoints[1] = DeepClone(value)),
], [
    "borderWidthLateralPointPairData2",
    params => DeepClone(params.insoleParams.borderWidthLateralPoints[2]),
    (params, value) => (params.insoleParams.borderWidthLateralPoints[2] = DeepClone(value)),
], [
    "borderWidthLateralPointPairData3",
    params => DeepClone(params.insoleParams.borderWidthLateralPoints[3]),
    (params, value) => (params.insoleParams.borderWidthLateralPoints[3] = DeepClone(value)),
], [
    "bwRegionBasedWidthProximalPoint",
    params => GetValidSideForBWRegionBasedWidth(params).proximalPoint,
    (params, value) => {
        params.insoleParams.borderWidthMedialPoints[0].proximalPoint = value;
        params.insoleParams.borderWidthLateralPoints[0].proximalPoint = value;
        params.insoleParams.regionBasedWidthProximalPoint = value; // For visualization
        params.insoleParams.regionBasedWidthWidth = 0;
    },
], [
    "bwRegionBasedWidthDistalPoint",
    params => GetValidSideForBWRegionBasedWidth(params).distalPoint,
    (params, value) => {
        params.insoleParams.borderWidthMedialPoints[0].distalPoint = value;
        params.insoleParams.borderWidthLateralPoints[0].distalPoint = value;
        params.insoleParams.regionBasedWidthDistalPoint = value; // For visualization
        params.insoleParams.regionBasedWidthWidth = 0;
    },
], [
    "bwRegionBasedWidthWidth",
    params => GetValidSideForBWRegionBasedWidth(params).distalWidth,
    (params, value) => {
        params.insoleParams.borderWidthMedialPoints[0].distalWidth = value;
        params.insoleParams.borderWidthLateralPoints[0].distalWidth = value;
    },
], [
    "bwRegionBasedWidthSmoothing",
    params => GetValidSideForBWRegionBasedWidth(params).smoothing,
    (params, value) => {
        params.insoleParams.borderWidthMedialPoints[0].smoothing = value;
        params.insoleParams.borderWidthLateralPoints[0].smoothing = value;
    },
], [
    "bwRegionBasedWidthLockDistal",
    params => GetValidSideForBWRegionBasedWidth(params).lockDistal,
    (params, value) => {
        params.insoleParams.borderWidthMedialPoints[0].lockDistal = value;
        params.insoleParams.borderWidthLateralPoints[0].lockDistal = value;
    },
], [
    "bwRegionBasedWidthMedialSideEnabled",
    params => params.insoleParams.borderWidthMedialSideEnabled && params.insoleParams.borderWidthNumMedialPointPairs > 0,
    (params, value) => {
        params.insoleParams.borderWidthMedialSideEnabled = value;
        params.insoleParams.borderWidthNumMedialPointPairs = value ? usedBorderWidthPairs : 0;
    },
], [
    "bwRegionBasedWidthLateralSideEnabled",
    params => params.insoleParams.borderWidthLateralSideEnabled &&
        params.insoleParams.borderWidthNumLateralPointPairs > 0,
    (params, value) => {
        params.insoleParams.borderWidthLateralSideEnabled = value;
        params.insoleParams.borderWidthNumLateralPointPairs = value ? usedBorderWidthPairs : 0;
    },
], [
    "currentCutoutShapeType",
    params => params.insoleParams.cutoutShapes[selectedCutoutShapeIndex].boundaryShape.shape,
    (params, value) => (params.insoleParams.cutoutShapes[selectedCutoutShapeIndex].boundaryShape.shape = value),
], [
    "currentCutoutSizeD1",
    params => params.insoleParams.cutoutShapes[selectedCutoutShapeIndex].boundaryShape.diameterX,
    (params, value) => (params.insoleParams.cutoutShapes[selectedCutoutShapeIndex].boundaryShape.diameterX = value),
], [
    "currentCutoutSizeD2",
    params => params.insoleParams.cutoutShapes[selectedCutoutShapeIndex].boundaryShape.diameterY,
    (params, value) => (params.insoleParams.cutoutShapes[selectedCutoutShapeIndex].boundaryShape.diameterY = value),
], [
    "currentCutoutRotation",
    params => params.insoleParams.cutoutShapes[selectedCutoutShapeIndex].boundaryShape.rotationDegrees,
    (params, value) => (params.insoleParams.cutoutShapes[selectedCutoutShapeIndex].boundaryShape.rotationDegrees = value),
], [
    "currentCutoutLocationU",
    params => params.insoleParams.cutoutShapes[selectedCutoutShapeIndex].boundaryShape.referencePointU,
    (params, value) => (params.insoleParams.cutoutShapes[selectedCutoutShapeIndex].boundaryShape.referencePointU = value),
], [
    "currentCutoutLocationV",
    params => params.insoleParams.cutoutShapes[selectedCutoutShapeIndex].boundaryShape.referencePointV,
    (params, value) => (params.insoleParams.cutoutShapes[selectedCutoutShapeIndex].boundaryShape.referencePointV = value),
], [
    "currentCutoutCustomShapeNumCps",
    params => params.insoleParams.cutoutShapes[selectedCutoutShapeIndex].boundaryShape.customShape.numPoints,
    (params, value) => (params.insoleParams.cutoutShapes[selectedCutoutShapeIndex].boundaryShape.customShape.numPoints = value),
], [
    "currentCutoutCustomShapeCps",
    params => DeepClone(params.insoleParams.cutoutShapes[selectedCutoutShapeIndex].boundaryShape.customShape.points),
    (params, value) => (params.insoleParams.cutoutShapes[selectedCutoutShapeIndex].boundaryShape.customShape.points =
        DeepClone(value)),
], [
    "cutoutShapeData0",
    params => DeepClone(params.insoleParams.cutoutShapes[0]),
    (params, value) => (params.insoleParams.cutoutShapes[0] = DeepClone(value)),
], [
    "cutoutShapeData1",
    params => DeepClone(params.insoleParams.cutoutShapes[1]),
    (params, value) => (params.insoleParams.cutoutShapes[1] = DeepClone(value)),
], [
    "cutoutShapeData2",
    params => DeepClone(params.insoleParams.cutoutShapes[2]),
    (params, value) => (params.insoleParams.cutoutShapes[2] = DeepClone(value)),
], [
    "cutoutShapeData3",
    params => DeepClone(params.insoleParams.cutoutShapes[3]),
    (params, value) => (params.insoleParams.cutoutShapes[3] = DeepClone(value)),
], [
    "currentReductionShapeEnabled",
    params => params.insoleParams.reductionShapes[selectedReductionShapeIndex].boundaryShape.shape !== "None",
    (params, value) => {
        params.insoleParams.reductionShapes[selectedReductionShapeIndex].boundaryShape.shape = value
            ? reductionShapeTypes[selectedReductionShapeIndex] // Reset to original shape
            : "None";
    },
], [
    "currentReductionShapeType",
    params => params.insoleParams.reductionShapes[selectedReductionShapeIndex].boundaryShape.shape,
    (params, value) => (params.insoleParams.reductionShapes[selectedReductionShapeIndex].boundaryShape.shape = value),
], [
    "currentReductionSizeD1",
    params => params.insoleParams.reductionShapes[selectedReductionShapeIndex].boundaryShape.diameterX,
    (params, value) => (params.insoleParams.reductionShapes[selectedReductionShapeIndex].boundaryShape.diameterX = value),
], [
    "currentReductionSizeD2",
    params => params.insoleParams.reductionShapes[selectedReductionShapeIndex].boundaryShape.diameterY,
    (params, value) => (params.insoleParams.reductionShapes[selectedReductionShapeIndex].boundaryShape.diameterY = value),
], [
    "currentReductionRotation",
    params => params.insoleParams.reductionShapes[selectedReductionShapeIndex].boundaryShape.rotationDegrees,
    (params, value) => (params.insoleParams.reductionShapes[selectedReductionShapeIndex].boundaryShape.rotationDegrees = value),
], [
    "currentReductionLocationU",
    params => params.insoleParams.reductionShapes[selectedReductionShapeIndex].boundaryShape.referencePointU,
    (params, value) => (params.insoleParams.reductionShapes[selectedReductionShapeIndex].boundaryShape.referencePointU = value),
], [
    "currentReductionLocationV",
    params => params.insoleParams.reductionShapes[selectedReductionShapeIndex].boundaryShape.referencePointV,
    (params, value) => (params.insoleParams.reductionShapes[selectedReductionShapeIndex].boundaryShape.referencePointV = value),
], [
    "reductionShapeDataHeel",
    params => DeepClone(params.insoleParams.reductionShapes[0]),
    (params, value) => (params.insoleParams.reductionShapes[0] = DeepClone(value)),
], [
    "reductionShapeDataMedialArch",
    params => DeepClone(params.insoleParams.reductionShapes[1]),
    (params, value) => (params.insoleParams.reductionShapes[1] = DeepClone(value)),
], [
    "reductionShapeDataLateralArch",
    params => DeepClone(params.insoleParams.reductionShapes[2]),
    (params, value) => (params.insoleParams.reductionShapes[2] = DeepClone(value)),
], [
    "reductionShapeDataMetatarsal",
    params => DeepClone(params.insoleParams.reductionShapes[3]),
    (params, value) => (params.insoleParams.reductionShapes[3] = DeepClone(value)),
], [
    "currentDomesAndWellsShapeType",
    params => params.insoleParams.domesAndWellsShapes[selectedDomesAndWellsShapeIndex].shape,
    (params, value) => (params.insoleParams.domesAndWellsShapes[selectedDomesAndWellsShapeIndex].shape = value),
], [
    "currentDomesAndWellsHeight",
    params => params.insoleParams.domesAndWellsShapes[selectedDomesAndWellsShapeIndex].height,
    (params, value) => (params.insoleParams.domesAndWellsShapes[selectedDomesAndWellsShapeIndex].height = value),
], [
    "currentDomesAndWellsSizeD1",
    params => params.insoleParams.domesAndWellsShapes[selectedDomesAndWellsShapeIndex].diameterX,
    (params, value) => (params.insoleParams.domesAndWellsShapes[selectedDomesAndWellsShapeIndex].diameterX = value),
], [
    "currentDomesAndWellsSizeD2",
    params => params.insoleParams.domesAndWellsShapes[selectedDomesAndWellsShapeIndex].diameterY,
    (params, value) => (params.insoleParams.domesAndWellsShapes[selectedDomesAndWellsShapeIndex].diameterY = value),
], [
    "currentDomesAndWellsSlopeS1",
    params => params.insoleParams.domesAndWellsShapes[selectedDomesAndWellsShapeIndex].falloffX1,
    (params, value) => (params.insoleParams.domesAndWellsShapes[selectedDomesAndWellsShapeIndex].falloffX1 = value),
], [
    "currentDomesAndWellsSlopeS2",
    params => params.insoleParams.domesAndWellsShapes[selectedDomesAndWellsShapeIndex].falloffX2,
    (params, value) => (params.insoleParams.domesAndWellsShapes[selectedDomesAndWellsShapeIndex].falloffX2 = value),
], [
    "currentDomesAndWellsRotation",
    params => params.insoleParams.domesAndWellsShapes[selectedDomesAndWellsShapeIndex].rotationDegrees,
    (params, value) => (params.insoleParams.domesAndWellsShapes[selectedDomesAndWellsShapeIndex].rotationDegrees = value),
], [
    "currentDomesAndWellsLocationU",
    params => params.insoleParams.domesAndWellsShapes[selectedDomesAndWellsShapeIndex].referencePointU,
    (params, value) => (params.insoleParams.domesAndWellsShapes[selectedDomesAndWellsShapeIndex].referencePointU = value),
], [
    "currentDomesAndWellsLocationV",
    params => params.insoleParams.domesAndWellsShapes[selectedDomesAndWellsShapeIndex].referencePointV,
    (params, value) => (params.insoleParams.domesAndWellsShapes[selectedDomesAndWellsShapeIndex].referencePointV = value),
], [
    "currentDomesAndWellsCustomShapeNumCps",
    params => params.insoleParams.domesAndWellsShapes[selectedDomesAndWellsShapeIndex].customShapeNumCps,
    (params, value) => (params.insoleParams.domesAndWellsShapes[selectedDomesAndWellsShapeIndex].customShapeNumCps = value),
], [
    "currentDomesAndWellsCustomShapeCps",
    params => DeepClone(params.insoleParams.domesAndWellsShapes[selectedDomesAndWellsShapeIndex].customShapeCps),
    (params, value) => (params.insoleParams.domesAndWellsShapes[selectedDomesAndWellsShapeIndex].customShapeCps =
        DeepClone(value)),
], [
    "domesAndWellsShapeData0",
    params => DeepClone(params.insoleParams.domesAndWellsShapes[0]),
    (params, value) => (params.insoleParams.domesAndWellsShapes[0] = DeepClone(value)),
], [
    "domesAndWellsShapeData1",
    params => DeepClone(params.insoleParams.domesAndWellsShapes[1]),
    (params, value) => (params.insoleParams.domesAndWellsShapes[1] = DeepClone(value)),
], [
    "domesAndWellsShapeData2",
    params => DeepClone(params.insoleParams.domesAndWellsShapes[2]),
    (params, value) => (params.insoleParams.domesAndWellsShapes[2] = DeepClone(value)),
], [
    "domesAndWellsShapeData3",
    params => DeepClone(params.insoleParams.domesAndWellsShapes[3]),
    (params, value) => (params.insoleParams.domesAndWellsShapes[3] = DeepClone(value)),
], [
    "zoningShapesEnabledOnThick",
    params => params.insoleParams.solidParameters.enabled && params.zoningShapesEnabledOnThick,
    (params, value) => {
        params.zoningShapesEnabledOnThick = value;
    },
], [
    "zoningShapesVisibleOnThick",
    params => params.insoleParams.solidParameters.enabled &&
        params.zoningShapesEnabledOnThick &&
        params.zoningShapesVisibleOnThick,
    (params, value) => {
        params.zoningShapesVisibleOnThick = value;
        if (value) {
            params.zoningShapesVisibleOnLattice = false;
        }
    },
], 
// Lattice
[
    "latticeEnabled",
    params => params.exportParams.generateLatticeMesh,
    (params, value) => {
        params.exportParams.generateLatticeMesh = value;
        if (!value) {
            params.zoningShapesVisibleOnLattice = false;
        }
    },
], [
    "latticePreview",
    params => params.exportParams.generateLatticeMeshPreview,
    (params, value) => {
        if (params.exportParams.generateLatticeMeshPreview === value)
            return;
        params.exportParams.generateLatticeMeshPreview = value;
        if (!value) {
            const callback = (ev) => {
                if (ev.key === "latticePreview" && ev.value === false)
                    return;
                params.exportParams.generateLatticeMeshPreview = true;
                insoleParameterChanged.removeListener(callback);
            };
            insoleParameterChanged.addListener(callback);
        }
    },
], [
    "zoningShapesEnabledOnLattice",
    params => params.exportParams.generateLatticeMesh && params.zoningShapesEnabledOnLattice,
    (params, value) => {
        params.zoningShapesEnabledOnLattice = value;
        for (let i = 0; i < reductionShapeTypes.length; ++i) {
            const enabled = params.zoningShapesEnabledOnLattice && params.latticeEnabledZones[i];
            params.insoleParams.latticeParameters.zones[i].shape = enabled ? reductionShapeTypes[i] : "None";
        }
        if (!value) {
            params.zoningShapesVisibleOnLattice = false;
        }
    },
], [
    "latticeSelectedZoneEnabled",
    params => params.exportParams.generateLatticeMesh &&
        params.zoningShapesEnabledOnLattice &&
        params.latticeEnabledZones[params.selectedLatticeZoneIndex],
    (params, value) => {
        params.latticeEnabledZones[params.selectedLatticeZoneIndex] = value;
        params.insoleParams.latticeParameters.zones[params.selectedLatticeZoneIndex].shape = value
            ? reductionShapeTypes[params.selectedLatticeZoneIndex]
            : "None";
    },
], [
    "latticeSelectedZoneInnerBeamThickness",
    params => params.insoleParams.latticeParameters.zoneEdgeThickness[params.selectedLatticeZoneIndex],
    (params, value) => {
        params.insoleParams.latticeParameters.zoneEdgeThickness[params.selectedLatticeZoneIndex] = value;
    },
], [
    "latticeSelectedZoneSurfaceBeamThickness",
    params => params.insoleParams.latticeParameters.zoneBeamThickness[params.selectedLatticeZoneIndex],
    (params, value) => {
        params.insoleParams.latticeParameters.zoneBeamThickness[params.selectedLatticeZoneIndex] = value;
    },
], [
    "zoningShapesVisibleOnLattice",
    params => params.exportParams.generateLatticeMesh &&
        params.zoningShapesEnabledOnLattice &&
        params.zoningShapesVisibleOnLattice,
    (params, value) => {
        params.zoningShapesVisibleOnLattice = value;
        if (value) {
            params.zoningShapesVisibleOnThick = false;
        }
    },
], [
    "sulcusEnabled",
    params => params.insoleParams.insoleShape === "Sulcus",
    (params, value) => {
        if (value) {
            params.insoleParams.insoleShape = "Sulcus";
        }
        else if (params.insoleParams.insoleShape === "Sulcus") {
            params.insoleParams.insoleShape = "Met";
        }
    },
], [
    "leofullLengthEnabled",
    params => params.insoleParams.insoleShape === "Full",
    (params, value) => {
        if (value) {
            params.insoleParams.insoleShape = "Full";
        }
        else if (params.insoleParams.insoleShape === "Full") {
            params.insoleParams.insoleShape = "Met";
        }
    },
], [
    "leoMortonsEnabled",
    params => params.insoleParams.insoleShape === "Mortons",
    (params, value) => {
        if (value) {
            params.insoleParams.insoleShape = "Mortons";
        }
        else if (params.insoleParams.insoleShape === "Mortons") {
            params.insoleParams.insoleShape = "Met";
        }
    },
], [
    "gaitPlateEnabled",
    params => params.insoleParams.insoleShape === "GaitPlate",
    (params, value) => {
        if (value) {
            params.insoleParams.insoleShape = "GaitPlate";
        }
        else if (params.insoleParams.insoleShape === "GaitPlate") {
            params.insoleParams.insoleShape = "Met";
        }
    },
], [
    "gaitPlateReverse",
    params => params.insoleParams.insoleShape === "GaitPlate" && !params.insoleParams.sulcusParameters.reverse,
    (params, value) => {
        params.insoleParams.sulcusParameters.reverse = !value;
    },
]);
export function SetInsoleParameter(params, key, value) {
    if (IsNullish(value)) {
        return;
    }
    const customHandler = insoleParameterCustomHandlers.get(key);
    if (customHandler !== undefined) {
        customHandler.setter(params, value);
        return;
    }
    if (key in params.insoleParams) {
        if (typeof value !== "number" && typeof value !== "boolean" && typeof value !== "string") {
            // Don't assign values of complex types, because they are not deep copied
            // These values should be handled by setting it in `nonTopLevelInsoleParameters`
            return;
        }
        params.insoleParams[key] = value;
        return;
    }
    console.error("Unhandled parameter", key);
}
export function GetInsoleParameter(params, key) {
    const customHandler = insoleParameterCustomHandlers.get(key);
    if (customHandler !== undefined) {
        return customHandler.getter(params);
    }
    if (key in params.insoleParams) {
        const value = params.insoleParams[key];
        if (typeof value !== "number" && typeof value !== "boolean" && typeof value !== "string") {
            // See comment in `SetInsoleParameter`
            return null;
        }
        return value;
    }
    console.error("Unhandled parameter", key);
    return null;
}
//# sourceMappingURL=parameters.js.map